/*
 * @Author: Claude (Refactored)
 * @Date: 2025-12-31
 * @Description: 文件预览项包装组件（根据文件类型动态选择预览组件）
 */
import React from 'react';

import { MediaPlayerItem } from '../../common/components/MediaPlayerItem';
import { ExtendedUploadFile } from '../../common/types';

interface FilePreviewItemProps {
  file: ExtendedUploadFile;
  onDelete: (e: React.MouseEvent) => void;
}

/**
 * 文件预览项包装组件
 * 根据文件的扩展名和 MIME type 自动选择对应的预览组件
 * 使用统一的 MediaPlayerItem，自动检测是音频还是视频
 */
export const FilePreviewItem: React.FC<FilePreviewItemProps> = ({ file, onDelete }) => {
  return <MediaPlayerItem file={file} onDelete={onDelete} mediaType="auto" />;
};
